import type { NavigationGuard } from "vue-router";

// Resetting "tab history". On next tab, your focus will start at the top again
export function resetFocusGuard(): NavigationGuard {
  return () => {
    document.querySelector<HTMLElement>("#lemue-app")?.focus?.();

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement?.blur();
    }
  };
}
